import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-purch-request-create',
  templateUrl: './purch-request-create.component.html',
  styleUrls: ['./purch-request-create.component.css']
})
export class PurchRequestCreateComponent implements OnInit {
    purchInternalNo;

    public setting?: Setting;

    public selectListSuppliers: SupplierItem[] = [];

    public grid?: GridOptions;

    public creating = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.purchInternalNo = this.stateService.getStateParams()['purch_internal_no'];
    }

    private async loadSetting() {
        if (!!this.purchInternalNo) {
            this.setting = (await this.datatask.Post(2860, { purch_internal_no: this.purchInternalNo }))[0];
        }
    }

    private async loadSuppliers() {
        if (!this.setting) return;

        return this.selectListSuppliers = await this.datatask.Post(2862, this.setting);
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_purchrequestcreate_grid')
                .setLoadDataFunction({
                    method: 2861,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async createChanges() {
        if (!!this.setting) {
            try {
                this.creating = true;

                const response = (await this.datatask.Post(2863, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.go('purchhead', { purch_internal_no: response?.purch_internal_no });
                }
            } finally {
                this.creating = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadSuppliers();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    purch_heading: string;
    purch_internal_no: string;
    supplier_no: string;
    purch_request_no: string;
}

interface SupplierItem {
    supplier_no: string;
    supplier_name: string;
    orderby: number;
}
